import {getGrapherPublicWidgetOptions} from "./grapher-util";

import type {GrapherPublicWidgetOptions} from "./grapher-util";
import type {PerseusGrapherWidgetOptions} from "../../data-schema";
import type {WidgetLogic} from "../logic-export.types";

const defaultWidgetOptions: PerseusGrapherWidgetOptions = {
    graph: {
        labels: ["x", "y"],
        range: [
            [-10, 10],
            [-10, 10],
        ],
        step: [1, 1],
        backgroundImage: {
            url: null,
        },
        markings: "graph",
        rulerLabel: "",
        rulerTicks: 10,
        valid: true,
        showTooltips: false,
    },
    correct: {
        type: "linear",
        coords: null,
    },
    availableTypes: ["linear"],
};

const grapherWidgetLogic: WidgetLogic<
    PerseusGrapherWidgetOptions,
    GrapherPublicWidgetOptions
> = {
    name: "grapher",
    defaultWidgetOptions,
    getPublicWidgetOptions: getGrapherPublicWidgetOptions,
    accessible: (options) =>
        !options.graph.backgroundImage.url &&
        options.availableTypes.length === 1 &&
        options.availableTypes[0] !== "quadratic",
};

export default grapherWidgetLogic;
